<span class="timestamp-container">
  @if (isLoading) {
    <m-skeleton
      width="11rem"
      height="1rem"
      styleClass="refresh-time-skeleton me-2"></m-skeleton>
  } @else {
    <span class="latest-refresh-time-container" (click)="onRefreshTimeClick()">
      <span>
        {{ headerConfig.refreshTime?.label }} {{ latestRefreshTime }}
      </span>
    </span>
  }
</span>
@if (isRefreshTimePopupVisible) {
  <portal-popup
    [(dialogVisibility)]="isRefreshTimePopupVisible"
    dialogTitle="Data Updates"
    [dialogSubTitle]="dialogSubTitle"
    (dialogVisibilityChange)="closeDataUpdatesPopup()"
    [tableColumns]="refreshTimeTableColumns"
    [tableData]="refreshTimeTableData"></portal-popup>
}
